import { Controller, useFormContext } from "react-hook-form";
import { IQuestionForm, SubquestionForm } from "../../../../QuestionForm/QuestionForm";
import React, { useState } from "react";
import { Autocomplete, Chip, TextField } from "@mui/material";
import { observer } from "mobx-react-lite";
import { useMst } from "../../../../../mobx";
import { useLocation } from "react-router-dom";
import { parse } from "query-string";
import { QuestionQuery } from "../../../../../api/questions/typings";

export default observer(function () {
	const { control } = useFormContext<IQuestionForm | SubquestionForm>();
	const { skillsStore } = useMst();
	const { getSkills, getSkillsData } = skillsStore;
	const [loading, setLoading] = useState(false);
	const location = useLocation();
	const params = parse(location.search) as QuestionQuery;
	const defaultSkills = Array.isArray(params["filter[skills][]"])
		? params["filter[skills][]"]
		: params["filter[skills][]"]
		? [params["filter[skills][]"]]
		: [];

	const onOpen = async () => {
		setLoading(true);
		await getSkills();
		setLoading(false);
	};

	return (
		<Controller
			control={control}
			name={"skills"}
			defaultValue={defaultSkills.map((id) => getSkillsData.find((x) => x.id === id)).filter((x) => !!x)}
			render={({ field: { value, onChange } }) => (
				<Autocomplete
					value={value}
					onChange={(_, value) => onChange(value)}
					multiple
					fullWidth
					onOpen={onOpen}
					loading={loading}
					loadingText={"Загрузка..."}
					noOptionsText={"Нет опций"}
					disableCloseOnSelect
					renderInput={(params) => (
						<TextField
							{...params}
							variant="outlined"
							margin={"dense"}
							size={"small"}
							label={"Навыки"}
							placeholder={"Выберите навык"}
						/>
					)}
					getOptionLabel={(option) => option.title}
					renderTags={(values, getTagProps) =>
						values.map((value, i) => (
							<Chip
								color={"primary"}
								size={"small"}
								variant={"outlined"}
								label={value.title}
								{...getTagProps({ index: i })}
							/>
						))
					}
					renderOption={(props, option) => (
						<li {...props} key={option.title + option.id}>
							{option.title}
						</li>
					)}
					options={getSkillsData}
				/>
			)}
		/>
	);
});
